import { buildURL, request as req } from "@/api";

const request = ({ dispatch }, { method, url, body }) => {
  return req(method, url, body).catch((err) => {
    const errors = err.response.data.errors;
    dispatch("trackErrors", errors);
    const code = err.response && err.response.status;
    if (code === 401) {
      dispatch("snackError", "Unauthenticated");
      dispatch("logout");
    }
    throw err;
  });
};

const fetchResources = (
  { dispatch, commit },
  { parent, type, pathName, query }
) => {
  let url = buildURL({ parent, type: pathName || type, query });
  return dispatch("request", { url }).then((res) => {
    const resources = res.data;
    commit("setResources", { type, resources });
  });
};

export const fetchResource = (
  { dispatch, commit },
  { parent, type, id, query }
) => {
  let url = buildURL({ type, id, parent, query });
  return dispatch("request", { url }).then((res) => {
    const resource = res["data"];
    const included = res["included"];
    resource && commit("pushResource", resource);
    included && included.forEach((incl) => commit("pushResource", incl));
  });
};

export const saveResource = (
  { dispatch },
  { parent, type, id, query, body }
) => {
  const method = id ? "updateResource" : "createResource";
  return dispatch(method, { parent, type, id, query, body })
    .then(() => {
      dispatch("snackSuccess", "Saved succesfully.");
    })
    .catch(() => {
      dispatch("snackError", `An error appeared.`);
    });
};

export const createResource = (
  { dispatch, commit },
  { parent, type, body, query }
) => {
  const url = buildURL({ parent, type, query });
  return dispatch("request", { method: "POST", url, body }).then((res) => {
    const resource = res["data"];
    if (resource) {
      commit("pushResource", resource);
      commit("activate", resource);
    }
    const included = res["included"];
    included && included.forEach((incl) => commit("pushResource", incl));
  });
};

export const updateResource = (
  { dispatch, commit },
  { parent, type, pathName, id, body }
) => {
  parent = (type === "share" || pathName === "revoke") && parent;
  const url = buildURL({ parent, type: pathName || type, id });
  return dispatch("request", { method: "PUT", url, body }).then((res) => {
    const resource = res["data"];
    resource && commit("pushResource", resource);
  });
};

export const deleteResource = (
  { dispatch, commit },
  { type, pathName, id, primaryKey, parent, query }
) => {
  const url = buildURL({ parent, type: pathName || type, id, query });
  return dispatch("request", { method: "DELETE", url }).then((res) => {
    const primaryValue = primaryKey ? query[primaryKey] : id;
    const resource = res && res["data"];
    resource && commit("pushResource", resource);
    commit("deleteResource", { type, primaryKey, id: primaryValue });
    dispatch("snackSuccess", "Deleted succesfully.");
  });
};

const clearStore = ({ commit }) => {
  commit("campaigns/clear");
  commit("history/clear");
  commit("fields/clear");
  commit("queryMaps/clear");
  commit("users/clear");
  commit("invites/clear");
};

export default {
  request,
  fetchResources,
  fetchResource,
  saveResource,
  createResource,
  updateResource,
  deleteResource,
  clearStore,
};
